import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "./../../base/common-http-option";
import { ICoursePattern } from "src/app/interfaces/coursePattern";

@Injectable({
  providedIn: "root"
})
export class CoursePatternService {
  constructor(private core: CoreService) {}

  getList(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.coutsePattern.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  add(data: ICoursePattern): Observable<any> {
    return this.core.post(
      ServiceRoute.coutsePattern.add,
      data,
      new CommonHttpOption().headers
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.coutsePattern.getById + id,
      new CommonHttpOption().headers
    );
  }

  edit(data: ICoursePattern): Observable<any> {
    return this.core.put(
      ServiceRoute.coutsePattern.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.coutsePattern.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  patternActive(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.coutsePattern.PatternActive,
      data,
      new CommonHttpOption().headers
    );
  }

  getListByCourseTypeId(id: number, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.coutsePattern.getListByCourseTypeId + id,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
}
